












































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  balance = 0;

  dispatchType = "finance/balance";

  columns: any[] = [
    { title: "编号", dataIndex: "id", width: 100 },
    { title: "时间", dataIndex: "created_time", width: 150 },
    { title: "类型", scopedSlots: { customRender: "type" } },
    { title: "金额", scopedSlots: { customRender: "fee" } },
    { title: "名目", scopedSlots: { customRender: "title" } }
  ];

  async loadUserInfo() {
    const res = await this.$store.dispatch("users/detail", {
      id: this.userId
    });
    if (res && res.Data) {
      this.balance = res.Data.balance;
    }
  }

  mounted() {
    this.loadUserInfo();
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
